import { render, staticRenderFns } from "./TeacherAdditionalWorkGroupByDepart.vue?vue&type=template&id=2ce80da0&scoped=true"
import script from "./TeacherAdditionalWorkGroupByDepart.vue?vue&type=script&lang=js"
export * from "./TeacherAdditionalWorkGroupByDepart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce80da0",
  null
  
)

export default component.exports